// extracted by mini-css-extract-plugin
export default {"text-input":"yNtuhn0","text-input__element":"fErOP4K","text-input__label":"lHGesK1","text-input__icon":"rQiAYPo","text-input__input-message":"AEa5NZU","text-input--error":"QQKcEbJ"};